<template>
    <v-container>
        <v-card style="margin-bottom:10px">
            <v-card-title>
                {{$t('units')}}
            </v-card-title>
            <v-card-actions>
                <v-btn color="primary" :text="sms" :outlined="calls" @click="sms=false,calls=true">{{$t('callUnits')}}</v-btn>
                <v-btn color="primary" :text="calls" :outlined="sms" @click="sms=true,calls=false">{{$t('smsUnits')}}</v-btn>
                <v-spacer></v-spacer>
                <div class="text-center">
                    <v-dialog v-model="TransferUnits" width="500">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" v-bind="attrs" v-on="on" v-show="calls">
                                <v-icon left>mdi-share</v-icon> {{$t('transferUnitsToOtherSystem')}}
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                {{$t('transferUnitsToOtherSystem')}}
                            </v-card-title>
                            <v-card-text>
                                <v-text-field v-model="destination" :label="$t('targetNumber')"></v-text-field>
                                <v-text-field v-model="amount" :label="$t('transferAmount')"></v-text-field>
                                <p style="color:red;">{{$t('transferNotice')}}</p>
                                {{ statusTransfer }}
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="transfer">{{$t('confirmTransfer')}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
                <download-csv v-show="calls" :data="transactions" :class="$i18n.locale == 'en' ? 'ml-3' : 'mr-3'" :name="`פירוט יחידות שיחה מתאריך ${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}.csv`">
                    <v-btn color="primary" outlined>
                        <v-icon small left>mdi-download</v-icon> {{$t('downloadCsvTable')}}
                    </v-btn>
                </download-csv>
                <download-csv v-show="sms" :data="rows" :name="`פירוט יחידות סמס מתאריך ${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}.csv`">
                    <v-btn color="primary" outlined>
                        <v-icon small left>mdi-download</v-icon> {{$t('downloadCsvTable')}}
                    </v-btn>
                </download-csv>
            </v-card-actions>
        </v-card>
        <v-data-table v-show="calls" :headers="headers" :items="transactions" :items-per-page="-1" class="elevation-1"></v-data-table>
        <v-data-table v-show="sms" :headers="headers" :items="rows" :items-per-page="-1" class="elevation-1"></v-data-table>
    </v-container>
</template>
<script>
import axios from "axios";
export default {
    data: () => ({
        TransferUnits: false,
        destination: '',
        amount: '',
        statusTransfer: '',
        transactions: [

        ],
        rows: [

        ],
        calls: true,
        sms: false,
        csv: [],
    }),
    computed: {
        headers() {
            return [
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id'
                },
                { text: this.$t('actionTime'), value: 'transactionTime' },
                { text: this.$t('amount'), value: 'amount' },
                { text: this.$t('whoAction'), value: 'who' },
                { text: this.$t('actionDescription'), value: 'description' },
                { text: this.$t('newAmount'), value: 'newBalance' },
                { text: this.$t('newExpireDate'), value: 'expireDate' }
            ]
        }
    },
    methods: {
        loadData() {
            (async () => {
                const body = { token: sessionStorage.token };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetTransactions`, body);
                this.transactions = response.data.transactions;
            })();
            (async () => {
                const body = { token: sessionStorage.token };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetCustomerSmsTransactions`, body);
                this.rows = response.data.rows;
            })();
        },
        transfer() {
            (async () => {
                const body = { token: sessionStorage.token, destination: this.destination, amount: this.amount };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/TransferUnits`, body);
                if (response.data.responseStatus === "OK") {
                    this.statusTransfer = this.$t('unitsTransferSuccess')
                } else {
                    this.statusTransfer = this.$t('unitsTransferError')
                }
            })();
        },
    },
    beforeMount() {
        this.loadData();
    },
}
</script>